type ChargebeeProductName = 'sales-yearly' | 'sales-monthly' | 'crm-monthly' | 'crm-yearly'

// Chargebee doesn't allow changing product IDs, so we ended up with
// some slightly messy IDs in dev vs production.
export function getChargebeeProductId(product: ChargebeeProductName): string {
  const isLiveEnvironment = ['master', 'staging'].includes(process.env.DEPLOYMENT_STAGE || '')
  switch (product) {
    case 'sales-yearly':
      return isLiveEnvironment ? 'PaintScout-Sales-USD-Yearly' : 'PaintScout-Sales-Monthly-USD-Yearly'
    case 'sales-monthly':
      return isLiveEnvironment ? 'PaintScout-Sales-USD-Monthly' : 'PaintScout-Sales-Monthly-USD-Monthly'
    case 'crm-monthly':
      return isLiveEnvironment ? 'CRM-Add-On-USD-Monthly' : 'CRM-Add-On-2025-USD-Monthly'
    case 'crm-yearly':
      return isLiveEnvironment ? 'CRM-Add-On-USD-Yearly' : 'CRM-Add-On-2025-USD-Yearly'
  }
}
